import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ClipboardList, FileCheck2, Hourglass, Send, Trophy } from "lucide-react";
import { api } from "@/app/api";

const CATEGORY_ICONS = {
  new_ready: FileCheck2,
  in_progress: Hourglass,
  awaiting_learner: ClipboardList,
  submitted: Send,
  decisions: Trophy,
};

export default function PartnerDashboard() {
  const [data, setData] = useState(null);
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    api.get("/partner/dashboard").then((response) => setData(response.data)).catch(() => setData(null));
    api.get("/partner/applications").then((response) => setRecent(response.data.applications.slice(0, 5))).catch(() => {});
  }, []);

  if (!data) return <p className="text-sm text-slatey">Loading…</p>;

  return (
    <div data-testid="partner-dashboard" className="space-y-6">
      <div>
        <h1 className="font-display text-3xl font-bold text-ink">{data.partner}</h1>
        <p className="mt-1 text-sm text-slatey">Your OpenDegree applicant pipeline — {data.total} application{data.total === 1 ? "" : "s"}.</p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
        {Object.entries(data.categories).map(([key, count]) => {
          const Icon = CATEGORY_ICONS[key];
          return (
            <Link key={key} to={`/app/partner/applications${key === "new_ready" ? "?status=ready_for_partner_review" : ""}`} data-testid={`partner-category-${key}`}
              className="rounded-3xl border border-slate-200 bg-white p-5 transition-colors hover:border-cobalt/40">
              <Icon className="h-5 w-5 text-cobalt" />
              <p className="mt-3 font-display text-3xl font-bold text-ink">{count}</p>
              <p className="mt-1 text-xs font-bold text-slatey">{data.category_labels[key]}</p>
            </Link>
          );
        })}
      </div>

      <div className="rounded-3xl border border-slate-200 bg-white p-5">
        <div className="flex items-center justify-between">
          <h2 className="font-display text-xl font-bold text-ink">Latest applications</h2>
          <Link to="/app/partner/applications" data-testid="partner-view-all" className="inline-flex items-center gap-1 text-sm font-bold text-cobalt">View all <ArrowRight className="h-4 w-4" /></Link>
        </div>
        <ul className="mt-4 space-y-2">
          {recent.map((application) => (
            <li key={application.id}>
              <Link to={`/app/partner/applications/${application.id}`} data-testid={`partner-recent-${application.id}`}
                className="flex flex-wrap items-center justify-between gap-2 rounded-2xl bg-surface px-4 py-3 text-sm hover:bg-slate-100">
                <span className="font-semibold text-ink">{application.applicant} · {application.programme}</span>
                <span className="text-xs font-bold capitalize text-slatey">{application.status.replaceAll("_", " ")}</span>
              </Link>
            </li>
          ))}
          {recent.length === 0 && <li className="text-sm text-slatey">No applications yet.</li>}
        </ul>
      </div>
    </div>
  );
}
